/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IGetBreedCosts,
  IGetBreedCostsInterface,
} from "../IGetBreedCosts";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "hound",
        type: "uint256",
      },
    ],
    name: "getBreedCosts",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct MicroPayment.Struct",
        name: "",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct MicroPayment.Struct",
        name: "",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct MicroPayment.Struct",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IGetBreedCosts__factory {
  static readonly abi = _abi;
  static createInterface(): IGetBreedCostsInterface {
    return new utils.Interface(_abi) as IGetBreedCostsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IGetBreedCosts {
    return new Contract(address, _abi, signerOrProvider) as IGetBreedCosts;
  }
}
